import html from "./UpdateMobileNumberSurveyContainer.html"
import "../SurveyManager.js"
import "./SurveyModal.js"
import { getSurveyPlatforms } from '../../../helpers/surveyPlatformCompatibility';

var module = angular.module("ResearchKitApplicationModule");

module.component('updateMobileNumberSurveyContainer', {
	template: html,
	bindings: {
		showUpdateMobileNumberSurvey: '<',
		currentMobileNumber: '<',
		participantId: '<'
	},
	controller: 'updateMobileNumberSurveyContainerController',
	controllerAs: 'vm'
});

module.controller('updateMobileNumberSurveyContainerController', ["$scope", "$http", "ceUrl", "surveyManagerFactory", "$timeout",
	function ($scope, $http, ceUrl, surveyManagerFactory, $timeout) {
		var vm = this;
		vm.surveyClosed = false;

		function surveyFinished(reason) {
			vm.surveyClosed = true;

			if (vm.participantId) {
				$scope.$emit("updateContactInfoFinished", reason === "Completed");
			} else {
				$scope.$emit("surveyFinished", reason);
			}

			if (reason === "Completed") {
				$scope.$emit("reloadDashboard");
			}

			vm.surveyManager = null;
			vm.platforms = null;
		}

		this.$onChanges = function (changesObj) {
			if (!(changesObj.showUpdateMobileNumberSurvey && changesObj.showUpdateMobileNumberSurvey.currentValue))
				return;

			vm.surveyClosed = false;

			var getAccountUpdateUrl = null;
			if (vm.participantId) {
				getAccountUpdateUrl = 'api/researchkit/administration/participantsupport/' + vm.participantId + '/GetAccountUpdateSurvey?updateContactInfoType=mobilePhone';
			} else {
				getAccountUpdateUrl = 'api/researchkit/account/GetAccountUpdateSurvey?updateContactInfoType=mobilePhone';
			}

			$http.get(ceUrl.make(getAccountUpdateUrl)).then(
				function (response) {
					var surveyTemplate = response.data;
					vm.platforms = getSurveyPlatforms(surveyTemplate);

					vm.surveyManager = surveyManagerFactory.createSurveyManager({
						template: surveyTemplate,
						finishedCallback: surveyFinished
					}, {
						mode: "Survey",
						isCoordinatorEntered: false,
						analyticsEnabled: false
					});

					vm.surveyManager.startSurvey();
				},
				function (response) {
					alert(response.data);
					surveyFinished("Error");
					return;
				}
			);
		};

		$scope.$on("setStep", function (e, step) {
			if (step.identifier === 'MobilePhoneVerificationCode') handleMobileNumberEntered(step);
			if (step.identifier === 'WaitForMobileNumberConfirmation') handleMobileNumberVerify();
		});

		function handleMobileNumberEntered(step) {
			var stepResult = vm.surveyManager.getResult();
			var mobileNumber = stepResult.StepResults[0].QuestionResults[0].Answers[0];

			var textTemplate = vm.surveyManager.template.steps[1].text;
			vm.surveyManager.template.steps[1].text = textTemplate.replace("${phone}", mobileNumber);

			var beginUpdateMobilePhoneUrl = null;
			if (vm.participantId) {
				beginUpdateMobilePhoneUrl = 'api/researchkit/administration/participantsupport/' + vm.participantId + '/beginUpdateMobilePhone';
			} else {
				beginUpdateMobilePhoneUrl = 'api/researchkit/account/beginUpdateMobilePhone';
			}

			$http.post(ceUrl.make(beginUpdateMobilePhoneUrl), { NewMobilePhone: mobileNumber })
				.catch(function onError(errorResponse) {
					if (errorResponse.data.Message) {
						alert(errorResponse.data.Message);
					} else {
						alert(errorResponse.data);
					}
					vm.surveyManager.currentStepManager.back();
					return;
				});
		}

		function handleMobileNumberVerify() {
			var stepResult = vm.surveyManager.getResult();
			var mobileNumber = stepResult.StepResults[0].QuestionResults[0].Answers[0];
			var verificationCode = stepResult.StepResults[1].QuestionResults[0].Answers[0];

			var verifyMobilePhoneUrl = null;
			if (vm.participantId) {
				verifyMobilePhoneUrl = 'api/researchkit/administration/participantsupport/' + vm.participantId + '/verifyMobilePhoneNumber';
			}
			else {
				verifyMobilePhoneUrl = 'api/researchkit/account/verifyMobilePhoneNumber';
			}

			$http.post(ceUrl.make(verifyMobilePhoneUrl), { MobileNumber: mobileNumber, VerificationCode: verificationCode }).then(
				function () {
					vm.surveyManager.currentStepManager.continue();
				}).catch(function onError(errorResponse) {
					alert(errorResponse.data);
					stepResult.StepResults[1].QuestionResults[0].Answers = [];
					vm.surveyManager.currentStepManager.continue();
					return;
				});
		}

	}
]);